<template>
    <div style="width: 100%;height: 100%;">
        <div class="loader-wrap" v-show="loadingVideo">
            <div class="loader"></div>
        </div>
        <div id="main" v-if="account.account.login" @keyup.esc="hideTab">
            <ChannelList
                    v-show="tab.current == 'channels'"
                    ref="channelList"
                    :teletekaEnabled="teletekaEnabled"
                    @openChannel="openChannel"
                    @apiGetChannelList="apiGetChannelList"
            ></ChannelList>

            <MessagesList
                    v-show="tab.current == 'messages'"
            ></MessagesList>

            <Settings
                    v-show="tab.current == 'settings'"
                    ref="settings"
                    @getLogout="getLogout"
            ></Settings>

            <div id="player" :class="{'debug-mode': (debugSettings.statsEnabled || debugSettings.metricsEnabled)}">
                <Slideshow
                        v-show="channel && !channel.is_video"
                        ref="slideshow"
                ></Slideshow>

                <VideoPlayer
                        ref="myPlayer"
                ></VideoPlayer>

                <VideoControl
                        ref="videoControl"
                        :loadingVideo="loadingVideo"
                        :hls="hls"
                        :class="{loading:loadingChannel}"
                        @getLogout="getLogout"
                        @updateProgramInfo="updateProgramInfo"
                        @saveCurrentProgramToArchiveInfo="saveCurrentProgramToArchiveInfo"
                ></VideoControl>
            </div>

            <a href="#" class="close" @click.prevent="hideTab" v-show="tab.current && channel"><i class="icon-close"></i></a>
        </div>

        <Login
                ref="loginComponent"
        ></Login>

        <vueToast ref="toast"></vueToast>

        <modal class="modal" name="teleteka" width="200" height="200" @before-close="beforeModalClose">
            <div class="modal_content">
                <h4>
                    Передача окончена. Продолжить просмотр в архиве?
                </h4>
                <div class="modal_buttons">
                    <a href="#" @click.prevent="showNextArchivedProgram">Да ({{teletekaTimer}})</a>
                    <!--<a href="#" @click.prevent="dismissModal();showTab('channels');">Нет</a>-->
                    <a href="#" @click.prevent="dismissModal">Нет</a>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import 'vue-toast/dist/vue-toast.min.css'
    import vueToast from 'vue-toast'
    import {mapState, mapActions} from 'vuex'

    import ChannelList from './components/ChannelList.vue'
    import VideoControl from './components/VideoControl.vue'
    import MessagesList from './components/MessagesList.vue'
    import Settings from './components/Settings.vue'
    import VideoPlayer from './components/VideoPlayer.vue'
    import Login from './components/Login.vue'
    import Slideshow from './components/Slideshow.vue'

    import Server from './libs/server'

    export default {
        name: 'app',
        components: {ChannelList, MessagesList, Settings, VideoPlayer, VideoControl, vueToast, Login, Slideshow},
        data() {
            return {
                mode: 'live', // live | archive | teleteka
                deltaTime: 0,
                stream_url: false,
//                serverOffset: 0,
                hls: null,
                loadingVideo: true,
                showHiddenChannels: false,
                teletekaTimer: null,
                teletekaEnabled: true
            }
        },
        computed: {
            ...mapState({
                channel: state => state.channels.currentChannel,
                channels: state => state.channels.channels,
                groups: state => state.channels.groups,
                channelsAspectRatio: state => state.channels.channelsAspectRatio,
                account: state => state.login.account,
                toastMessage: state => state.toast.message,
                toastTheme: state => state.toast.theme,
                error: state => state.error.errorObject,
                videoAspectRatio: state => state.videoAspectRatio.object,
                loadingChannel: state => state.channels.loadingChannel,
                debugSettings: state => state.debug.debugSettings,
//                hls: state => state.video.hls,
                tab: state => state.tab.tab,
                protectionCode: state => state.channels.protectionCode,
                player: state => state.channels.player,
                nextProgram: state => state.epg.nextProgram
            })
        },
        watch: {
            teletekaEnabled() {
                try {
                    localStorage.setItem('kartinatvWebplayer_teletekaEnabled', this.teletekaEnabled ? 1 : 0);
                }
                catch (e) {
                }
            },
            error() {
                if (this.error.code) {
                    let message = false;
                    this.parseError(this.error.code)
                        .then((error) => {
                            message = error.message;
                            if (error.resetLogin) {
                                this.resetLogin();
                            }

                            this.showToast(message, 'error');
                            this.loadingVideo = false;
                        });
                }
                else {
                    console.error(this.error);
                }
            },
            toastMessage() {
                this.showToast(this.toastMessage, this.toastTheme)
            },
            stream_url() {
                this.setVideoPoster(this.channel.big_icon_link);
                this.setVideoSource(this.stream_url);
                this.setVideoAutoplay(true);
            },
            account() {
                if (this.account.account.login) {
                    this.apiGetChannelList();
                }
            }
        },
        created() {
            this.apiGetAccount();
        },
        mounted() {
            this.$refs.toast.setOptions({
                maxToasts: 6,
                position: 'right bottom'
            });
        },
        methods: {
            pause() {
                this.$refs.videoControl.pause();
            },
            ...mapActions([
                'getChannelList',
                'setCurrentChannel',
                'parseError',
                'getAccount',
                'updateEpg',
                'showError',
                'setCurrentProgram',
                'setNextProgram',
                'setMessageCount',
                'setLoadingChannel',
                'setVideoPoster',
                'setVideoSource',
                'setVideoAutoplay',
                'resetLogin',
                'showTab',
                'hideTab',
                'saveLastTab',
                'getUrl',
                'teletekaGetUrl',
                'checkProtectionCode',
                'setProtectionCode',
                'changeVideoAspectRatioIndex'
            ]),
            getLogout() {
                this.$refs.loginComponent.getLogout()
            },
            beforeModalClose(event) {
                if (this.teletekaTimer !== null) event.stop();
            },
            showNextArchivedProgram() {
                this.dismissModal();

                this.$refs.videoControl.play();

                this.openChannel({
                    channel: this.channel,
                    program: {
                        name: this.nextProgram.progname,
                        start: +this.nextProgram.ut_start,
                        end: +this.nextProgram.ut_end
                    }
                });

                if (this.nextProgram.newProgramInfo) {
                    this.$refs.channelList.archiveProgramInfo = this.nextProgram.newProgramInfo;
                    this.$refs.channelList.archiveProgramInfo.utStart = this.nextProgram.ut_start;
                }
                else {
                    this.$refs.channelList.archiveProgramInfo.index++;
                    this.$refs.channelList.archiveProgramInfo.utStart = this.nextProgram.ut_start;
                }
            },
            dismissModal() {
                this.teletekaTimer = null;
                this.$modal.hide('teleteka');
            },
            restoreWatching() {
                this.$refs.videoControl.resumeWatching();
            },
            saveCurrentProgramToArchiveInfo(program) {
                this.$refs.channelList.saveCurrentProgramToArchiveInfo(program);
            },
            updateProgramInfo() {
                return new Promise(resolve => {
                    if (this.mode === 'live') {
                        this.setCurrentProgram({
                            name: this.channel.epg_progname,
                            start: +this.channel.epg_start,
                            end: +this.channel.epg_end
                        });
                        this.$refs.videoControl.setLiveProgress();
                    }
                    if (this.mode === 'archive') {
                        this.$refs.channelList.getUpdatedProgramInfo()
                            .then(program => {
                                this.setCurrentProgram({
                                    name: program.progname,
                                    start: +program.ut_start,
                                    end: +program.ut_end
                                });

                                if (program.newProgramInfo) {
                                    this.$refs.channelList.archiveProgramInfo = program.newProgramInfo;
                                    this.$refs.channelList.archiveProgramInfo.utStart = program.ut_start;
                                }
                                else {
                                    this.$refs.channelList.archiveProgramInfo.index++;
                                    this.$refs.channelList.archiveProgramInfo.utStart = program.ut_start;
                                }

                                this.$refs.videoControl.setProgressToStart(program.ut_start);
                            });
                    }
                    if (this.mode === 'teleteka') {
                        this.$refs.channelList.getUpdatedProgramInfo()
                            .then(program => {
                                if (program.teleteka && this.teletekaEnabled) {
                                    this.openChannel({
                                        channel: this.channel,
                                        program: {
                                            name: program.progname,
                                            start: +program.ut_start,
                                            end: +program.ut_end,
                                            duration: +program.duration,
                                            teleteka: program.teleteka
                                        }
                                    });

                                    if (program.newProgramInfo) {
                                        this.$refs.channelList.archiveProgramInfo = program.newProgramInfo;
                                        this.$refs.channelList.archiveProgramInfo.utStart = program.ut_start;
                                    }
                                    else {
                                        this.$refs.channelList.archiveProgramInfo.index++;
                                        this.$refs.channelList.archiveProgramInfo.utStart = program.ut_start;
                                    }
                                }
                                else {
                                    this.$refs.videoControl.pause();
                                    this.setNextProgram(program);
                                    this.$modal.show('teleteka');
                                    this.startTeletekaTimer();
                                }

                                resolve();
                            });
                    }
                });
            },
            startTeletekaTimer() {
                this.teletekaTimer = 10;
                let timer = setInterval(() => {
                    if (this.teletekaTimer > 0) {
                        this.teletekaTimer--;
                    }
                    else {
                        clearInterval(timer);
                        if (this.teletekaTimer !== null) this.showNextArchivedProgram();
                    }
                }, 1000);
            },
            openChannel({channel, program, callback}) {
                this.checkProtectionCode(channel.is_protected)
                    .then(protectionCode => {
                        if (channel.is_protected && !protectionCode) return;

                        let mode;
                        if (!program) {
                            mode = 'live';
                        }
                        else {
                            if (program.teleteka && this.teletekaEnabled) {
                                mode = 'teleteka';
                            }
                            else {
                                mode = 'archive';
                            }
                        }
                        if (mode === 'teleteka') {
                            this.apiTeletekaGetUrl(program.teleteka)
                                .then(() => {
                                    this.setLoadingChannel(true);
                                    this.setProtectionCode(protectionCode);
                                    this.mode = mode;
                                    this.setCurrentChannel(channel);

                                    this.$refs.videoControl.setProgressToStart(program.start);
                                    this.setCurrentProgram(program);

                                    setTimeout(() => {
                                        this.$refs.videoControl.play();
                                    }, 500);

                                    this.changeVideoAspectRatioIndex(this.channelsAspectRatio[channel.id] || 0);

                                    if (!channel.is_protected) {
                                        try {
                                            localStorage.setItem('kartinatvWebplayer_defaultChannelId', channel.id);
                                        }
                                        catch (e) {
                                        }

                                        this.setProtectionCode('');
                                    }

                                    this.player.onended = () => {
                                        this.updateEpg();
                                        this.updateProgramInfo()
                                            .then(() => {
                                                this.$refs.videoControl.progress = 100;
                                            });
                                    };

                                    callback && callback();
                                });
                        }
                        else {
                            let gmt = program ? program.start : null;

                            this.apiGetUrl(channel.id, gmt, protectionCode)
                                .then(() => {
                                    this.setLoadingChannel(true);
                                    this.setProtectionCode(protectionCode);
                                    this.mode = mode;
                                    this.setCurrentChannel(channel);

                                    setTimeout(() => {
                                        this.$refs.videoControl.play();
                                    }, 500);

                                    if (!channel.is_video) {
                                        this.$refs.slideshow.startSlideshowTimer();
                                    }

                                    if (mode === 'live') {
                                        this.$refs.videoControl.setLiveProgress();
                                        this.setCurrentProgram({
                                            name: this.channel.epg_progname,
                                            start: +this.channel.epg_start,
                                            end: +this.channel.epg_end
                                        });
                                        this.saveCurrentProgramToArchiveInfo(null);
                                    }
                                    if (mode === 'archive') {
                                        this.$refs.videoControl.setProgressToStart(program.start);
                                        this.setCurrentProgram(program);
                                    }

                                    this.changeVideoAspectRatioIndex(this.channelsAspectRatio[channel.id] || 0);

                                    if (!channel.is_protected) {
                                        try {
                                            localStorage.setItem('kartinatvWebplayer_defaultChannelId', channel.id);
                                        }
                                        catch (e) {
                                        }

                                        this.setProtectionCode('');
                                    }

                                    this.player.onended = () => {
                                    };

                                    callback && callback();
                                });
                        }
                    });
            },
            // Подтягивает список каналов и устанавливает текущие передачи
            apiGetChannelList(showHiddenChannels, protectionCode, ignoreLastUpdated, callback) {
                return new Promise(resolve => {
                    let scroll = 68;
                    let el = document.querySelector('#channels');
                    if (el) {
                        scroll = el.scrollTop;
                    }

                    this.getChannelList({showHiddenChannels, protectionCode, ignoreLastUpdated})
                        .then(({messages, servertime}) => {
                            this.setMessageCount(messages);

                            let timeshiftValue = +this.account.settings.timeshift.value * 60 * 60 * 1000;

                            this.deltaTime = ((Date.now() - timeshiftValue) / 1000) - servertime;
//                                self.$parent.serverOffset = Math.floor(Date.now() - self.serverTime * 1000) // Todo: вычислять корректно сдвиг относительно сервера в часах

                            if (!this.channel) this.onStart();
                            else if (this.mode === 'live') this.updateCurrentChannel();

                            this.updateEpg();

                            this.$nextTick(() => {
                                if (el) {
                                    el.scrollTop = scroll;
                                }
                            });

                            callback && callback();
                            resolve();
                        })
                        .catch(err => {
                            this.showError(err);
                        });
                });
            },
            updateCurrentChannel() {
                let updatedChannel = this.channels.find(value => value.id === this.channel.id);
                if (updatedChannel) {
                    this.setCurrentChannel(updatedChannel);
                }
            },
            onStart() {
                this.showTab('channels');

                let channelIdFromLocalStorage;
                try {
                    channelIdFromLocalStorage = +localStorage.getItem('kartinatvWebplayer_defaultChannelId');
                }
                catch (e) {
                    channelIdFromLocalStorage = null;
                }
                if (channelIdFromLocalStorage) {
                    let defaultChannel = this.channels.find(value => value.id === channelIdFromLocalStorage) || this.channels[0];
                    this.$nextTick(() => {
                        if (document.querySelector(`[data-cid="${defaultChannel.id}"]`))
                            document.querySelector(`[data-cid="${defaultChannel.id}"]`).scrollIntoView(true);
                    });
                }

                try {
                    this.teletekaEnabled = localStorage.getItem('kartinatvWebplayer_teletekaEnabled')
                }
                catch (e) {
                    this.teletekaEnabled = null;
                }
                if (this.teletekaEnabled) {
                    this.teletekaEnabled = Boolean(+this.teletekaEnabled);
                }
                else {
                    this.teletekaEnabled = true;
                }
            },
            apiTeletekaGetUrl(id) {
                return new Promise(resolve => {
                    this.hideTab();
                    this.teletekaGetUrl(id)
                        .then(data => {
                            let timeshiftValue = +this.account.settings.timeshift.value * 60 * 60 * 1000;

                            this.stream_url = data.url;
                            this.deltaTime = ((Date.now() - timeshiftValue) / 1000) - data.servertime;
                            resolve();
                        })
                        .catch(error => {
                            this.showError(error);
                        });
                });
            },
            apiGetUrl(cid, gmt, protectionCode) {
                return new Promise((resolve, reject) => {
                    let timeshiftValue = +this.account.settings.timeshift.value * 60 * 60 * 1000;

                    if (gmt) gmt -= this.deltaTime;

                    this.getUrl({cid, gmt, protectionCode})
                        .then(data => {
                            if (data.url === 'protected') {
                                this.showError({code: 7});
                            }
                            else {
                                this.stream_url = data.url;
                                this.deltaTime = ((Date.now() - timeshiftValue) / 1000) - data.servertime;
                                this.hideTab();
                                resolve();
                            }
                        })
                        .catch(error => {
                            this.showError(error);
                        });
                });
            },
            apiGetAccount() {
                this.saveLastTab('channels');

                this.getAccount()
                    .then(data => {
                        this.showToast('Сессия обновлена', 'info');

                        if (this.account.settings.stream_standard.value != 'hls_h264') { // Todo: пока принимаем только стандарт HLS
                            this.account.settings.stream_standard.value = 'hls_h264';
                            this.apiSendSettings('stream_standard');
                        }
                    })
                    .catch(err => {
                        this.showError(err);
                    });
            },
            apiSendSettings(k) {
                Server.sendSettings(k, this.account.settings[k].value, (err, data) => {
                    if (err)
                        console.error(err.message);
                    else {
                        if (data.error) {
                            this.showError(data.error);
                        }
                        else {
                            let serverDescription = this.account.settings.stream_server.list.find(server => server.ip === this.account.settings[k].value);
                            if (serverDescription) serverDescription = serverDescription.descr;
                            else serverDescription = this.account.settings[k].value;

                            this.showToast(`Настройки обновлены (${k}=${serverDescription})`, 'info');
                        }
                    }
                })
            },
            showToast(message, theme) {
                this.$refs.toast.showToast(message, {
                    theme: theme,
                    timeLife: 3000,
                    closeBtn: false
                })
            }
        }
    }

</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,700,900&subset=cyrillic');

    html, body, #main, #player {
        width: 100%;
        height: 100%;
        background: #2a2a2a url(./assets/43a9a631.png);
        /*background: #000;*/
        color: #fff;
        margin: 0;
        padding: 0;
        font-family: 'Roboto', sans-serif;
        overflow: hidden;
        position: relative;
    }

    #player video {
        /*height: calc(100% - 86px);*/
        height: 100%;
        width: 100%;
        margin: auto;
        display: block;
        background: #000;
        /*z-index: 2;*/
        /*position: relative;*/
        object-position: center;
    }

    #player video.zoom {
        object-fit: cover;
    }

    #player video.ratio-4-3 {
        object-fit: fill;
        width: 135vh;
    }

    #player video.ratio-16-9 {
        object-fit: fill;
        /*width: 156.25vh;*/
        /*width: 143.75vh;*/
        width: 181.75vh;
    }

    #player.debug-mode {
        overflow: auto !important;
    }

    .screen {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
    }

    .clear {
        clear: both;
    }

    h1, h2, h3, h4, input, button {
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
    }

    #login ul, #login li {
        margin: 0;
        padding: 0;
        list-style: none;
        list-style-position: inside;
    }

    #login .error-msg {
        background: #983d3b;
        padding: 5px 10px;
        margin-top: 20px;
        text-align: center;
    }

    #login > div {
        width: 480px;
        height: 560px;
        position: absolute;
        left: 50%;
        margin-left: -240px;
        top: 50%;
        margin-top: -280px;
        font-weight: 300;
        text-shadow: 1px 1px 6px #222;
    }

    #login h1 {
        text-align: center;
        line-height: 56px;
        margin: -32px 0 48px;
        font-size: 56px;
    }

    #login h1 img {
        margin: 32px 10px -32px;
    }

    #login h2 {
        text-align: center;
        font-size: 24px;
        text-transform: uppercase;
        line-height: 28px;
        margin: 12px 0 0;
    }

    #login h3 {
        text-align: center;
        line-height: 42px;
        font-size: 42px;
        margin: 0;
    }

    #login a {
        color: #fff;
        text-decoration: none;
    }

    #login a:hover {
        color: #f98d0b;
    }

    #login form {
        padding: 0 40px;
    }

    #login label {
        margin: 4px 0 0;
        line-height: 36px;
        font-size: 19px;
        text-align: center;
        text-transform: uppercase;
        display: block;
        width: 100%;
    }

    #login input {
        background: rgba(0, 0, 0, .25);
        border: solid 1px rgba(0, 0, 0, .25);
        border-bottom: solid 1px rgba(255, 255, 255, .15);
        display: block;
        padding: 8px 0;
        width: 100%;
        font-size: 24px;
        color: #efefef;
        text-align: center;
        overflow: hidden;
        border-radius: 8px;
        margin-bottom: 12px;
    }

    #login button {
        background: #f76d1a;
        border: solid 1px rgba(255, 255, 255, .25);
        border-bottom: solid 1px rgba(0, 0, 0, .25);
        text-transform: uppercase;
        padding: 8px 0;
        width: 180px;
        font-size: 19px;
        text-align: center;
        overflow: hidden;
        border-radius: 8px;
        margin: 20px auto 32px;
        display: block;
        color: #fff;
        text-shadow: 1px 1px 4px rgba(0, 0, 0, .25);
    }

    #login #shop {
        display: block;
        font-size: 19px;
        color: #fff;
        text-decoration: none;
        text-align: center;
    }

    #login #shop:hover {
        color: #f98d0b;
    }

    #sidenav {
        height: 100vh;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: rgba(0, 0, 0, 0.2);
    }

    #sidenav > ul > li:last-child {
        position: absolute;
        bottom: 0;
    }

    #sidenav > ul > li.active {
        background-color: #3f3f3f;
    }

    #sidenav > ul > li > span {
        display: inline-block;
        padding: 12px 15px;
        line-height: 14px;
        margin: 0;
        width: 15px;
        height: 18px;
        text-align: center;
        cursor: pointer;
        position: relative;
        border-bottom: solid 1px #3f3f3f;
    }

    #sidenav > ul > li:last-child span {
        border-bottom: 0;
        border-top: solid 1px #3f3f3f;
    }

    #sidenav > ul > li > span > span {
        position: absolute;
        display: inline-block;
        top: 6px;
        right: 2px;
        background: #eeac32;
        border-radius: 7px;
        font-size: 8px;
        line-height: 10px;
        width: 10px;
        text-align: center;
        padding: 2px;
        color: #000;
        font-weight: bold;
    }

    #sidenav > ul > li > div {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        margin-left: 45px;
        background: rgba(0, 0, 0, 0.2);
        width: 320px;
    }

    #sidenav .panels > li {
        height: 100vh;
    }

    #sidenav > ul > li > span#epgBtn {
        display: none;
    }

    .vue-toast-manager_container {
        z-index: 1000
    }

    .vue-toast_message {
        padding: 10px 12px !important;
    }

    ::-webkit-scrollbar { /* Let's get this party started */
        width: 6px;
    }

    ::-webkit-scrollbar-track { /* Track */
        /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
        -webkit-border-radius: 2px;
        border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb { /* Handle */
        -webkit-border-radius: 2px;
        border-radius: 2px;
        background: #555;
        /*background: rgba(255,0,0,0.8);*/
        /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);*/
    }

    ::-webkit-scrollbar-thumb:window-inactive {
        background: #2a2a2a;
        /*background: rgba(255,0,0,0.4);*/
    }

    *:focus {
        outline: #999;
    }

    a.close {
        position: fixed;
        display: block;
        top: 10px;
        right: 10px;
        width: 33px;
        height: 33px;
        padding: 10px;
        font-size: 33px;
        line-height: 33px;
        text-align: center;
        z-index: 999;
        text-decoration: none;
        color: #fff;
    }

    .video-js {
        height: 100%;
    }

    video::-webkit-media-controls {
        display: none !important;
    }

    .loader-wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 10;
        /*background: rgba(255, 255, 255, 0.88);*/
        /*background: #fff;*/
        /*background: #2a2a2a url(./assets/43a9a631.png);*/
        background: #000;
    }

    .loader {
        position: absolute;
        /*top: 50%;*/
        /*left: 50%;*/
        /*border: 4px solid rgba(204,204,204,0.17);*/
        /*border-left-color: rgba(255,140,0,0.98);*/
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        box-shadow: 0px 2px 0px #ff5c00;
        border-radius: 50%;
        /*margin: -69px 0 0 -69px;*/
        height: 100px;
        width: 100px;
        animation: load-rotate 700ms linear infinite;
    }

    @keyframes load-rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes load-rotate {
        100% {
            -o-transform: rotate(360deg);
        }
    }

    @-ms-keyframes load-rotate {
        100% {
            -ms-transform: rotate(360deg);
        }
    }

    @-webkit-keyframes load-rotate {
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @-moz-keyframes load-rotate {
        100% {
            -moz-transform: rotate(360deg);
        }
    }

    .default-select {
        text-transform: uppercase;
        /*display: block;*/
        width: 100%;
        padding: 6px;
        background: rgba(0, 0, 0, .25);
        border: solid 1px rgba(0, 0, 0, .25);
        border-bottom: solid 1px rgba(255, 255, 255, .15);
        border-radius: 6px;
        margin: 4px 0;
        color: #fff;
        font-size: 21px;
    }

    .default-select option {
        background: #2a2a2a;
        border: 0;
    }

    .slideshow {
        width: 100%;
        height: 100%;
    }

    .slideshow img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: opacity 0.5s;
        position: absolute;
    }

    .slideshow img.fade-out {
        opacity: 0;
    }

    .modal {
        color: #000
    }

    .modal_content {
        padding: 20px;
    }

    .modal_buttons {
        text-align: center;
        display: flex;
        justify-content: space-around;
    }
</style>


// WEBPACK FOOTER //
// App.vue?a9203f14